import React from "react";

// Helper for creating <select> options with the given option pre-selected
function optionTag(val, name, selectedVal) {
  return val === selectedVal ? (
    <option value={val} defaultValue="selected">
      {name}
    </option>
  ) : (
    <option value={val}>{name}</option>
  );
}

const Language = ({ onChange, selectedLang }) => {
  return (
    <div className="form-group">
      <select
        className="custom-select rounded"
        id="language"
        name="language"
        onChange={onChange}
      >
        {optionTag("de", "German", selectedLang)}
        {optionTag("en", "English", selectedLang)}
      </select>
    </div>
  );
};

export default Language;
